import React from 'react';
import './InfoTermsPage.scss';
import Spinner from 'Components/Shared/Spinner/Spinner';
import WrapperLayout from 'Components/Shared/WrapperLayout/WrapperLayout';

interface IProps {
  isFetching: boolean;
  content: Julius.Website.TermsPageViewModel;
}

const InfoTermsPage: React.SFC<IProps> = ({
  isFetching,
  content,
}) => {

  if (isFetching) {
    return <Spinner height='lg' />;
  }

  if (!content) {
    return null;
  }

  return (
    <WrapperLayout style='info-terms-page' padding='xl'>
      <div className='title'>{ content.title }</div>
      <div dangerouslySetInnerHTML={ { __html: content.text } } />
    </WrapperLayout>
  );
};

export default InfoTermsPage;


// WEBPACK FOOTER //
// ./src/pages/InfoTermsPage/InfoTermsPage.tsx